import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import useFeatureGuard from '../subscriptions/useFeatureGuard';
import { Feature } from '../../types/subscriptions';
import { getMarketingData } from '../../services/marketing';

function useGetMarketingData() {
  const { user } = useUser();

  const hasMarketingFeature = useFeatureGuard(Feature.MARKETING);

  const isEnabled = !!user && !!user?.business?.id && hasMarketingFeature;

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: ['marketingData', user?.business?.id, hasMarketingFeature],
    queryFn: async () => {
      if (!user?.business?.id) return null;
      const result = await getMarketingData({
        businessId: user?.business?.id,
        create: true,
        includeCampaigns: true,
        includeSenders: true,
        includeCreditsUsage: true,
        includeEmbed: true,
      });
      return result;
    },
    enabled: isEnabled,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return {
    isEnabled,
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
}

export default useGetMarketingData;
